// source: messages/pdf.message.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

goog.exportSymbol('proto.pdf_messages.CcsPdfInfo', null, global);
goog.exportSymbol('proto.pdf_messages.GenerateCcsPdfBatchRequest', null, global);
goog.exportSymbol('proto.pdf_messages.GenerateCcsPdfBatchResponse', null, global);
goog.exportSymbol('proto.pdf_messages.GenerateCcsPdfBatchResult', null, global);
goog.exportSymbol('proto.pdf_messages.GenerateCcsPdfRequest', null, global);
goog.exportSymbol('proto.pdf_messages.GenerateCcsPdfResponse', null, global);
goog.exportSymbol('proto.pdf_messages.GenerateNpaPdfRequest', null, global);
goog.exportSymbol('proto.pdf_messages.GenerateNpaPdfResponse', null, global);
goog.exportSymbol('proto.pdf_messages.NpaPdfInfo', null, global);
goog.exportSymbol('proto.pdf_messages.RenderRequest', null, global);
goog.exportSymbol('proto.pdf_messages.RenderResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pdf_messages.RenderRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pdf_messages.RenderRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pdf_messages.RenderRequest.displayName = 'proto.pdf_messages.RenderRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pdf_messages.RenderResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pdf_messages.RenderResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pdf_messages.RenderResponse.displayName = 'proto.pdf_messages.RenderResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pdf_messages.GenerateCcsPdfRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pdf_messages.GenerateCcsPdfRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pdf_messages.GenerateCcsPdfRequest.displayName = 'proto.pdf_messages.GenerateCcsPdfRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pdf_messages.CcsPdfInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pdf_messages.CcsPdfInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pdf_messages.CcsPdfInfo.displayName = 'proto.pdf_messages.CcsPdfInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pdf_messages.GenerateCcsPdfResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pdf_messages.GenerateCcsPdfResponse.repeatedFields_, null);
};
goog.inherits(proto.pdf_messages.GenerateCcsPdfResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pdf_messages.GenerateCcsPdfResponse.displayName = 'proto.pdf_messages.GenerateCcsPdfResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pdf_messages.GenerateCcsPdfBatchRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pdf_messages.GenerateCcsPdfBatchRequest.repeatedFields_, null);
};
goog.inherits(proto.pdf_messages.GenerateCcsPdfBatchRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pdf_messages.GenerateCcsPdfBatchRequest.displayName = 'proto.pdf_messages.GenerateCcsPdfBatchRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pdf_messages.GenerateCcsPdfBatchResult = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pdf_messages.GenerateCcsPdfBatchResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pdf_messages.GenerateCcsPdfBatchResult.displayName = 'proto.pdf_messages.GenerateCcsPdfBatchResult';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pdf_messages.GenerateCcsPdfBatchResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pdf_messages.GenerateCcsPdfBatchResponse.repeatedFields_, null);
};
goog.inherits(proto.pdf_messages.GenerateCcsPdfBatchResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pdf_messages.GenerateCcsPdfBatchResponse.displayName = 'proto.pdf_messages.GenerateCcsPdfBatchResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pdf_messages.GenerateNpaPdfRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pdf_messages.GenerateNpaPdfRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pdf_messages.GenerateNpaPdfRequest.displayName = 'proto.pdf_messages.GenerateNpaPdfRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pdf_messages.NpaPdfInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pdf_messages.NpaPdfInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pdf_messages.NpaPdfInfo.displayName = 'proto.pdf_messages.NpaPdfInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pdf_messages.GenerateNpaPdfResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pdf_messages.GenerateNpaPdfResponse.repeatedFields_, null);
};
goog.inherits(proto.pdf_messages.GenerateNpaPdfResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pdf_messages.GenerateNpaPdfResponse.displayName = 'proto.pdf_messages.GenerateNpaPdfResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pdf_messages.RenderRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pdf_messages.RenderRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pdf_messages.RenderRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pdf_messages.RenderRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
templateId: jspb.Message.getFieldWithDefault(msg, 1, ""),
data: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pdf_messages.RenderRequest}
 */
proto.pdf_messages.RenderRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pdf_messages.RenderRequest;
  return proto.pdf_messages.RenderRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pdf_messages.RenderRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pdf_messages.RenderRequest}
 */
proto.pdf_messages.RenderRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTemplateId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pdf_messages.RenderRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pdf_messages.RenderRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pdf_messages.RenderRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pdf_messages.RenderRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTemplateId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getData();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string template_id = 1;
 * @return {string}
 */
proto.pdf_messages.RenderRequest.prototype.getTemplateId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pdf_messages.RenderRequest} returns this
 */
proto.pdf_messages.RenderRequest.prototype.setTemplateId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string data = 2;
 * @return {string}
 */
proto.pdf_messages.RenderRequest.prototype.getData = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pdf_messages.RenderRequest} returns this
 */
proto.pdf_messages.RenderRequest.prototype.setData = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pdf_messages.RenderResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pdf_messages.RenderResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pdf_messages.RenderResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pdf_messages.RenderResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
filename: jspb.Message.getFieldWithDefault(msg, 2, ""),
url: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pdf_messages.RenderResponse}
 */
proto.pdf_messages.RenderResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pdf_messages.RenderResponse;
  return proto.pdf_messages.RenderResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pdf_messages.RenderResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pdf_messages.RenderResponse}
 */
proto.pdf_messages.RenderResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilename(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pdf_messages.RenderResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pdf_messages.RenderResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pdf_messages.RenderResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pdf_messages.RenderResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFilename();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string filename = 2;
 * @return {string}
 */
proto.pdf_messages.RenderResponse.prototype.getFilename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pdf_messages.RenderResponse} returns this
 */
proto.pdf_messages.RenderResponse.prototype.setFilename = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string url = 3;
 * @return {string}
 */
proto.pdf_messages.RenderResponse.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.pdf_messages.RenderResponse} returns this
 */
proto.pdf_messages.RenderResponse.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pdf_messages.GenerateCcsPdfRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pdf_messages.GenerateCcsPdfRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pdf_messages.GenerateCcsPdfRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pdf_messages.GenerateCcsPdfRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
claimId: jspb.Message.getFieldWithDefault(msg, 1, 0),
templateId: jspb.Message.getFieldWithDefault(msg, 2, ""),
claimData: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pdf_messages.GenerateCcsPdfRequest}
 */
proto.pdf_messages.GenerateCcsPdfRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pdf_messages.GenerateCcsPdfRequest;
  return proto.pdf_messages.GenerateCcsPdfRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pdf_messages.GenerateCcsPdfRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pdf_messages.GenerateCcsPdfRequest}
 */
proto.pdf_messages.GenerateCcsPdfRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setClaimId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTemplateId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setClaimData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pdf_messages.GenerateCcsPdfRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pdf_messages.GenerateCcsPdfRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pdf_messages.GenerateCcsPdfRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pdf_messages.GenerateCcsPdfRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClaimId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getTemplateId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getClaimData();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional int32 claim_id = 1;
 * @return {number}
 */
proto.pdf_messages.GenerateCcsPdfRequest.prototype.getClaimId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.pdf_messages.GenerateCcsPdfRequest} returns this
 */
proto.pdf_messages.GenerateCcsPdfRequest.prototype.setClaimId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string template_id = 2;
 * @return {string}
 */
proto.pdf_messages.GenerateCcsPdfRequest.prototype.getTemplateId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pdf_messages.GenerateCcsPdfRequest} returns this
 */
proto.pdf_messages.GenerateCcsPdfRequest.prototype.setTemplateId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string claim_data = 3;
 * @return {string}
 */
proto.pdf_messages.GenerateCcsPdfRequest.prototype.getClaimData = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.pdf_messages.GenerateCcsPdfRequest} returns this
 */
proto.pdf_messages.GenerateCcsPdfRequest.prototype.setClaimData = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pdf_messages.CcsPdfInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.pdf_messages.CcsPdfInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pdf_messages.CcsPdfInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pdf_messages.CcsPdfInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
filename: jspb.Message.getFieldWithDefault(msg, 1, ""),
url: jspb.Message.getFieldWithDefault(msg, 2, ""),
fileId: jspb.Message.getFieldWithDefault(msg, 3, ""),
benefitCode: jspb.Message.getFieldWithDefault(msg, 4, ""),
sizeBytes: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pdf_messages.CcsPdfInfo}
 */
proto.pdf_messages.CcsPdfInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pdf_messages.CcsPdfInfo;
  return proto.pdf_messages.CcsPdfInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pdf_messages.CcsPdfInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pdf_messages.CcsPdfInfo}
 */
proto.pdf_messages.CcsPdfInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilename(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setBenefitCode(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSizeBytes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pdf_messages.CcsPdfInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pdf_messages.CcsPdfInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pdf_messages.CcsPdfInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pdf_messages.CcsPdfInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFilename();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFileId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getBenefitCode();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSizeBytes();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
};


/**
 * optional string filename = 1;
 * @return {string}
 */
proto.pdf_messages.CcsPdfInfo.prototype.getFilename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pdf_messages.CcsPdfInfo} returns this
 */
proto.pdf_messages.CcsPdfInfo.prototype.setFilename = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string url = 2;
 * @return {string}
 */
proto.pdf_messages.CcsPdfInfo.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pdf_messages.CcsPdfInfo} returns this
 */
proto.pdf_messages.CcsPdfInfo.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string file_id = 3;
 * @return {string}
 */
proto.pdf_messages.CcsPdfInfo.prototype.getFileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.pdf_messages.CcsPdfInfo} returns this
 */
proto.pdf_messages.CcsPdfInfo.prototype.setFileId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string benefit_code = 4;
 * @return {string}
 */
proto.pdf_messages.CcsPdfInfo.prototype.getBenefitCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.pdf_messages.CcsPdfInfo} returns this
 */
proto.pdf_messages.CcsPdfInfo.prototype.setBenefitCode = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 size_bytes = 5;
 * @return {number}
 */
proto.pdf_messages.CcsPdfInfo.prototype.getSizeBytes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.pdf_messages.CcsPdfInfo} returns this
 */
proto.pdf_messages.CcsPdfInfo.prototype.setSizeBytes = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pdf_messages.GenerateCcsPdfResponse.repeatedFields_ = [7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pdf_messages.GenerateCcsPdfResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pdf_messages.GenerateCcsPdfResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pdf_messages.GenerateCcsPdfResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pdf_messages.GenerateCcsPdfResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
filename: jspb.Message.getFieldWithDefault(msg, 2, ""),
sizeBytes: jspb.Message.getFieldWithDefault(msg, 3, 0),
url: jspb.Message.getFieldWithDefault(msg, 4, ""),
fileId: jspb.Message.getFieldWithDefault(msg, 5, ""),
benefitCode: jspb.Message.getFieldWithDefault(msg, 6, ""),
additionalPdfsList: jspb.Message.toObjectList(msg.getAdditionalPdfsList(),
    proto.pdf_messages.CcsPdfInfo.toObject, includeInstance),
totalPdfCount: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pdf_messages.GenerateCcsPdfResponse}
 */
proto.pdf_messages.GenerateCcsPdfResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pdf_messages.GenerateCcsPdfResponse;
  return proto.pdf_messages.GenerateCcsPdfResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pdf_messages.GenerateCcsPdfResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pdf_messages.GenerateCcsPdfResponse}
 */
proto.pdf_messages.GenerateCcsPdfResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilename(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSizeBytes(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileId(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setBenefitCode(value);
      break;
    case 7:
      var value = new proto.pdf_messages.CcsPdfInfo;
      reader.readMessage(value,proto.pdf_messages.CcsPdfInfo.deserializeBinaryFromReader);
      msg.addAdditionalPdfs(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalPdfCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pdf_messages.GenerateCcsPdfResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pdf_messages.GenerateCcsPdfResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pdf_messages.GenerateCcsPdfResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pdf_messages.GenerateCcsPdfResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFilename();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSizeBytes();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getFileId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getBenefitCode();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getAdditionalPdfsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.pdf_messages.CcsPdfInfo.serializeBinaryToWriter
    );
  }
  f = message.getTotalPdfCount();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
};


/**
 * optional string filename = 2;
 * @return {string}
 */
proto.pdf_messages.GenerateCcsPdfResponse.prototype.getFilename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pdf_messages.GenerateCcsPdfResponse} returns this
 */
proto.pdf_messages.GenerateCcsPdfResponse.prototype.setFilename = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 size_bytes = 3;
 * @return {number}
 */
proto.pdf_messages.GenerateCcsPdfResponse.prototype.getSizeBytes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.pdf_messages.GenerateCcsPdfResponse} returns this
 */
proto.pdf_messages.GenerateCcsPdfResponse.prototype.setSizeBytes = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string url = 4;
 * @return {string}
 */
proto.pdf_messages.GenerateCcsPdfResponse.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.pdf_messages.GenerateCcsPdfResponse} returns this
 */
proto.pdf_messages.GenerateCcsPdfResponse.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string file_id = 5;
 * @return {string}
 */
proto.pdf_messages.GenerateCcsPdfResponse.prototype.getFileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.pdf_messages.GenerateCcsPdfResponse} returns this
 */
proto.pdf_messages.GenerateCcsPdfResponse.prototype.setFileId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string benefit_code = 6;
 * @return {string}
 */
proto.pdf_messages.GenerateCcsPdfResponse.prototype.getBenefitCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.pdf_messages.GenerateCcsPdfResponse} returns this
 */
proto.pdf_messages.GenerateCcsPdfResponse.prototype.setBenefitCode = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * repeated CcsPdfInfo additional_pdfs = 7;
 * @return {!Array<!proto.pdf_messages.CcsPdfInfo>}
 */
proto.pdf_messages.GenerateCcsPdfResponse.prototype.getAdditionalPdfsList = function() {
  return /** @type{!Array<!proto.pdf_messages.CcsPdfInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.pdf_messages.CcsPdfInfo, 7));
};


/**
 * @param {!Array<!proto.pdf_messages.CcsPdfInfo>} value
 * @return {!proto.pdf_messages.GenerateCcsPdfResponse} returns this
*/
proto.pdf_messages.GenerateCcsPdfResponse.prototype.setAdditionalPdfsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.pdf_messages.CcsPdfInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.pdf_messages.CcsPdfInfo}
 */
proto.pdf_messages.GenerateCcsPdfResponse.prototype.addAdditionalPdfs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.pdf_messages.CcsPdfInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pdf_messages.GenerateCcsPdfResponse} returns this
 */
proto.pdf_messages.GenerateCcsPdfResponse.prototype.clearAdditionalPdfsList = function() {
  return this.setAdditionalPdfsList([]);
};


/**
 * optional int32 total_pdf_count = 8;
 * @return {number}
 */
proto.pdf_messages.GenerateCcsPdfResponse.prototype.getTotalPdfCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.pdf_messages.GenerateCcsPdfResponse} returns this
 */
proto.pdf_messages.GenerateCcsPdfResponse.prototype.setTotalPdfCount = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pdf_messages.GenerateCcsPdfBatchRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pdf_messages.GenerateCcsPdfBatchRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pdf_messages.GenerateCcsPdfBatchRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pdf_messages.GenerateCcsPdfBatchRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pdf_messages.GenerateCcsPdfBatchRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
claimIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
templateId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pdf_messages.GenerateCcsPdfBatchRequest}
 */
proto.pdf_messages.GenerateCcsPdfBatchRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pdf_messages.GenerateCcsPdfBatchRequest;
  return proto.pdf_messages.GenerateCcsPdfBatchRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pdf_messages.GenerateCcsPdfBatchRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pdf_messages.GenerateCcsPdfBatchRequest}
 */
proto.pdf_messages.GenerateCcsPdfBatchRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt32() : [reader.readInt32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addClaimIds(values[i]);
      }
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTemplateId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pdf_messages.GenerateCcsPdfBatchRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pdf_messages.GenerateCcsPdfBatchRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pdf_messages.GenerateCcsPdfBatchRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pdf_messages.GenerateCcsPdfBatchRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClaimIdsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      1,
      f
    );
  }
  f = message.getTemplateId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * repeated int32 claim_ids = 1;
 * @return {!Array<number>}
 */
proto.pdf_messages.GenerateCcsPdfBatchRequest.prototype.getClaimIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.pdf_messages.GenerateCcsPdfBatchRequest} returns this
 */
proto.pdf_messages.GenerateCcsPdfBatchRequest.prototype.setClaimIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.pdf_messages.GenerateCcsPdfBatchRequest} returns this
 */
proto.pdf_messages.GenerateCcsPdfBatchRequest.prototype.addClaimIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pdf_messages.GenerateCcsPdfBatchRequest} returns this
 */
proto.pdf_messages.GenerateCcsPdfBatchRequest.prototype.clearClaimIdsList = function() {
  return this.setClaimIdsList([]);
};


/**
 * optional string template_id = 2;
 * @return {string}
 */
proto.pdf_messages.GenerateCcsPdfBatchRequest.prototype.getTemplateId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pdf_messages.GenerateCcsPdfBatchRequest} returns this
 */
proto.pdf_messages.GenerateCcsPdfBatchRequest.prototype.setTemplateId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pdf_messages.GenerateCcsPdfBatchResult.prototype.toObject = function(opt_includeInstance) {
  return proto.pdf_messages.GenerateCcsPdfBatchResult.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pdf_messages.GenerateCcsPdfBatchResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pdf_messages.GenerateCcsPdfBatchResult.toObject = function(includeInstance, msg) {
  var f, obj = {
claimId: jspb.Message.getFieldWithDefault(msg, 1, 0),
success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
url: jspb.Message.getFieldWithDefault(msg, 3, ""),
fileId: jspb.Message.getFieldWithDefault(msg, 4, ""),
filename: jspb.Message.getFieldWithDefault(msg, 5, ""),
error: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pdf_messages.GenerateCcsPdfBatchResult}
 */
proto.pdf_messages.GenerateCcsPdfBatchResult.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pdf_messages.GenerateCcsPdfBatchResult;
  return proto.pdf_messages.GenerateCcsPdfBatchResult.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pdf_messages.GenerateCcsPdfBatchResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pdf_messages.GenerateCcsPdfBatchResult}
 */
proto.pdf_messages.GenerateCcsPdfBatchResult.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setClaimId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilename(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pdf_messages.GenerateCcsPdfBatchResult.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pdf_messages.GenerateCcsPdfBatchResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pdf_messages.GenerateCcsPdfBatchResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pdf_messages.GenerateCcsPdfBatchResult.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClaimId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getFileId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getFilename();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getError();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional int32 claim_id = 1;
 * @return {number}
 */
proto.pdf_messages.GenerateCcsPdfBatchResult.prototype.getClaimId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.pdf_messages.GenerateCcsPdfBatchResult} returns this
 */
proto.pdf_messages.GenerateCcsPdfBatchResult.prototype.setClaimId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.pdf_messages.GenerateCcsPdfBatchResult.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pdf_messages.GenerateCcsPdfBatchResult} returns this
 */
proto.pdf_messages.GenerateCcsPdfBatchResult.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional string url = 3;
 * @return {string}
 */
proto.pdf_messages.GenerateCcsPdfBatchResult.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.pdf_messages.GenerateCcsPdfBatchResult} returns this
 */
proto.pdf_messages.GenerateCcsPdfBatchResult.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string file_id = 4;
 * @return {string}
 */
proto.pdf_messages.GenerateCcsPdfBatchResult.prototype.getFileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.pdf_messages.GenerateCcsPdfBatchResult} returns this
 */
proto.pdf_messages.GenerateCcsPdfBatchResult.prototype.setFileId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string filename = 5;
 * @return {string}
 */
proto.pdf_messages.GenerateCcsPdfBatchResult.prototype.getFilename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.pdf_messages.GenerateCcsPdfBatchResult} returns this
 */
proto.pdf_messages.GenerateCcsPdfBatchResult.prototype.setFilename = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string error = 6;
 * @return {string}
 */
proto.pdf_messages.GenerateCcsPdfBatchResult.prototype.getError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.pdf_messages.GenerateCcsPdfBatchResult} returns this
 */
proto.pdf_messages.GenerateCcsPdfBatchResult.prototype.setError = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pdf_messages.GenerateCcsPdfBatchResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pdf_messages.GenerateCcsPdfBatchResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pdf_messages.GenerateCcsPdfBatchResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pdf_messages.GenerateCcsPdfBatchResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pdf_messages.GenerateCcsPdfBatchResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
resultsList: jspb.Message.toObjectList(msg.getResultsList(),
    proto.pdf_messages.GenerateCcsPdfBatchResult.toObject, includeInstance),
totalCount: jspb.Message.getFieldWithDefault(msg, 2, 0),
successCount: jspb.Message.getFieldWithDefault(msg, 3, 0),
failureCount: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pdf_messages.GenerateCcsPdfBatchResponse}
 */
proto.pdf_messages.GenerateCcsPdfBatchResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pdf_messages.GenerateCcsPdfBatchResponse;
  return proto.pdf_messages.GenerateCcsPdfBatchResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pdf_messages.GenerateCcsPdfBatchResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pdf_messages.GenerateCcsPdfBatchResponse}
 */
proto.pdf_messages.GenerateCcsPdfBatchResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pdf_messages.GenerateCcsPdfBatchResult;
      reader.readMessage(value,proto.pdf_messages.GenerateCcsPdfBatchResult.deserializeBinaryFromReader);
      msg.addResults(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalCount(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSuccessCount(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFailureCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pdf_messages.GenerateCcsPdfBatchResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pdf_messages.GenerateCcsPdfBatchResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pdf_messages.GenerateCcsPdfBatchResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pdf_messages.GenerateCcsPdfBatchResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getResultsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.pdf_messages.GenerateCcsPdfBatchResult.serializeBinaryToWriter
    );
  }
  f = message.getTotalCount();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getSuccessCount();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getFailureCount();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * repeated GenerateCcsPdfBatchResult results = 1;
 * @return {!Array<!proto.pdf_messages.GenerateCcsPdfBatchResult>}
 */
proto.pdf_messages.GenerateCcsPdfBatchResponse.prototype.getResultsList = function() {
  return /** @type{!Array<!proto.pdf_messages.GenerateCcsPdfBatchResult>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.pdf_messages.GenerateCcsPdfBatchResult, 1));
};


/**
 * @param {!Array<!proto.pdf_messages.GenerateCcsPdfBatchResult>} value
 * @return {!proto.pdf_messages.GenerateCcsPdfBatchResponse} returns this
*/
proto.pdf_messages.GenerateCcsPdfBatchResponse.prototype.setResultsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.pdf_messages.GenerateCcsPdfBatchResult=} opt_value
 * @param {number=} opt_index
 * @return {!proto.pdf_messages.GenerateCcsPdfBatchResult}
 */
proto.pdf_messages.GenerateCcsPdfBatchResponse.prototype.addResults = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.pdf_messages.GenerateCcsPdfBatchResult, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pdf_messages.GenerateCcsPdfBatchResponse} returns this
 */
proto.pdf_messages.GenerateCcsPdfBatchResponse.prototype.clearResultsList = function() {
  return this.setResultsList([]);
};


/**
 * optional int32 total_count = 2;
 * @return {number}
 */
proto.pdf_messages.GenerateCcsPdfBatchResponse.prototype.getTotalCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.pdf_messages.GenerateCcsPdfBatchResponse} returns this
 */
proto.pdf_messages.GenerateCcsPdfBatchResponse.prototype.setTotalCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 success_count = 3;
 * @return {number}
 */
proto.pdf_messages.GenerateCcsPdfBatchResponse.prototype.getSuccessCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.pdf_messages.GenerateCcsPdfBatchResponse} returns this
 */
proto.pdf_messages.GenerateCcsPdfBatchResponse.prototype.setSuccessCount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 failure_count = 4;
 * @return {number}
 */
proto.pdf_messages.GenerateCcsPdfBatchResponse.prototype.getFailureCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.pdf_messages.GenerateCcsPdfBatchResponse} returns this
 */
proto.pdf_messages.GenerateCcsPdfBatchResponse.prototype.setFailureCount = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pdf_messages.GenerateNpaPdfRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pdf_messages.GenerateNpaPdfRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pdf_messages.GenerateNpaPdfRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pdf_messages.GenerateNpaPdfRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
attyId: jspb.Message.getFieldWithDefault(msg, 1, 0),
templateId: jspb.Message.getFieldWithDefault(msg, 2, ""),
npaData: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pdf_messages.GenerateNpaPdfRequest}
 */
proto.pdf_messages.GenerateNpaPdfRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pdf_messages.GenerateNpaPdfRequest;
  return proto.pdf_messages.GenerateNpaPdfRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pdf_messages.GenerateNpaPdfRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pdf_messages.GenerateNpaPdfRequest}
 */
proto.pdf_messages.GenerateNpaPdfRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAttyId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTemplateId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setNpaData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pdf_messages.GenerateNpaPdfRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pdf_messages.GenerateNpaPdfRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pdf_messages.GenerateNpaPdfRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pdf_messages.GenerateNpaPdfRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAttyId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getTemplateId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getNpaData();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional int32 atty_id = 1;
 * @return {number}
 */
proto.pdf_messages.GenerateNpaPdfRequest.prototype.getAttyId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.pdf_messages.GenerateNpaPdfRequest} returns this
 */
proto.pdf_messages.GenerateNpaPdfRequest.prototype.setAttyId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string template_id = 2;
 * @return {string}
 */
proto.pdf_messages.GenerateNpaPdfRequest.prototype.getTemplateId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pdf_messages.GenerateNpaPdfRequest} returns this
 */
proto.pdf_messages.GenerateNpaPdfRequest.prototype.setTemplateId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string npa_data = 3;
 * @return {string}
 */
proto.pdf_messages.GenerateNpaPdfRequest.prototype.getNpaData = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.pdf_messages.GenerateNpaPdfRequest} returns this
 */
proto.pdf_messages.GenerateNpaPdfRequest.prototype.setNpaData = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pdf_messages.NpaPdfInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.pdf_messages.NpaPdfInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pdf_messages.NpaPdfInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pdf_messages.NpaPdfInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
filename: jspb.Message.getFieldWithDefault(msg, 1, ""),
url: jspb.Message.getFieldWithDefault(msg, 2, ""),
fileId: jspb.Message.getFieldWithDefault(msg, 3, ""),
benefitCode: jspb.Message.getFieldWithDefault(msg, 4, ""),
sizeBytes: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pdf_messages.NpaPdfInfo}
 */
proto.pdf_messages.NpaPdfInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pdf_messages.NpaPdfInfo;
  return proto.pdf_messages.NpaPdfInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pdf_messages.NpaPdfInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pdf_messages.NpaPdfInfo}
 */
proto.pdf_messages.NpaPdfInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilename(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setBenefitCode(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSizeBytes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pdf_messages.NpaPdfInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pdf_messages.NpaPdfInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pdf_messages.NpaPdfInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pdf_messages.NpaPdfInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFilename();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFileId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getBenefitCode();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSizeBytes();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
};


/**
 * optional string filename = 1;
 * @return {string}
 */
proto.pdf_messages.NpaPdfInfo.prototype.getFilename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pdf_messages.NpaPdfInfo} returns this
 */
proto.pdf_messages.NpaPdfInfo.prototype.setFilename = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string url = 2;
 * @return {string}
 */
proto.pdf_messages.NpaPdfInfo.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pdf_messages.NpaPdfInfo} returns this
 */
proto.pdf_messages.NpaPdfInfo.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string file_id = 3;
 * @return {string}
 */
proto.pdf_messages.NpaPdfInfo.prototype.getFileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.pdf_messages.NpaPdfInfo} returns this
 */
proto.pdf_messages.NpaPdfInfo.prototype.setFileId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string benefit_code = 4;
 * @return {string}
 */
proto.pdf_messages.NpaPdfInfo.prototype.getBenefitCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.pdf_messages.NpaPdfInfo} returns this
 */
proto.pdf_messages.NpaPdfInfo.prototype.setBenefitCode = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 size_bytes = 5;
 * @return {number}
 */
proto.pdf_messages.NpaPdfInfo.prototype.getSizeBytes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.pdf_messages.NpaPdfInfo} returns this
 */
proto.pdf_messages.NpaPdfInfo.prototype.setSizeBytes = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pdf_messages.GenerateNpaPdfResponse.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pdf_messages.GenerateNpaPdfResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pdf_messages.GenerateNpaPdfResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pdf_messages.GenerateNpaPdfResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pdf_messages.GenerateNpaPdfResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
filename: jspb.Message.getFieldWithDefault(msg, 2, ""),
sizeBytes: jspb.Message.getFieldWithDefault(msg, 3, 0),
url: jspb.Message.getFieldWithDefault(msg, 4, ""),
fileId: jspb.Message.getFieldWithDefault(msg, 5, ""),
additionalPdfsList: jspb.Message.toObjectList(msg.getAdditionalPdfsList(),
    proto.pdf_messages.NpaPdfInfo.toObject, includeInstance),
totalPdfCount: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pdf_messages.GenerateNpaPdfResponse}
 */
proto.pdf_messages.GenerateNpaPdfResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pdf_messages.GenerateNpaPdfResponse;
  return proto.pdf_messages.GenerateNpaPdfResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pdf_messages.GenerateNpaPdfResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pdf_messages.GenerateNpaPdfResponse}
 */
proto.pdf_messages.GenerateNpaPdfResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilename(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSizeBytes(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileId(value);
      break;
    case 6:
      var value = new proto.pdf_messages.NpaPdfInfo;
      reader.readMessage(value,proto.pdf_messages.NpaPdfInfo.deserializeBinaryFromReader);
      msg.addAdditionalPdfs(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalPdfCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pdf_messages.GenerateNpaPdfResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pdf_messages.GenerateNpaPdfResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pdf_messages.GenerateNpaPdfResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pdf_messages.GenerateNpaPdfResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFilename();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSizeBytes();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getFileId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getAdditionalPdfsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.pdf_messages.NpaPdfInfo.serializeBinaryToWriter
    );
  }
  f = message.getTotalPdfCount();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
};


/**
 * optional string filename = 2;
 * @return {string}
 */
proto.pdf_messages.GenerateNpaPdfResponse.prototype.getFilename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pdf_messages.GenerateNpaPdfResponse} returns this
 */
proto.pdf_messages.GenerateNpaPdfResponse.prototype.setFilename = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 size_bytes = 3;
 * @return {number}
 */
proto.pdf_messages.GenerateNpaPdfResponse.prototype.getSizeBytes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.pdf_messages.GenerateNpaPdfResponse} returns this
 */
proto.pdf_messages.GenerateNpaPdfResponse.prototype.setSizeBytes = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string url = 4;
 * @return {string}
 */
proto.pdf_messages.GenerateNpaPdfResponse.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.pdf_messages.GenerateNpaPdfResponse} returns this
 */
proto.pdf_messages.GenerateNpaPdfResponse.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string file_id = 5;
 * @return {string}
 */
proto.pdf_messages.GenerateNpaPdfResponse.prototype.getFileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.pdf_messages.GenerateNpaPdfResponse} returns this
 */
proto.pdf_messages.GenerateNpaPdfResponse.prototype.setFileId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * repeated NpaPdfInfo additional_pdfs = 6;
 * @return {!Array<!proto.pdf_messages.NpaPdfInfo>}
 */
proto.pdf_messages.GenerateNpaPdfResponse.prototype.getAdditionalPdfsList = function() {
  return /** @type{!Array<!proto.pdf_messages.NpaPdfInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.pdf_messages.NpaPdfInfo, 6));
};


/**
 * @param {!Array<!proto.pdf_messages.NpaPdfInfo>} value
 * @return {!proto.pdf_messages.GenerateNpaPdfResponse} returns this
*/
proto.pdf_messages.GenerateNpaPdfResponse.prototype.setAdditionalPdfsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.pdf_messages.NpaPdfInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.pdf_messages.NpaPdfInfo}
 */
proto.pdf_messages.GenerateNpaPdfResponse.prototype.addAdditionalPdfs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.pdf_messages.NpaPdfInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pdf_messages.GenerateNpaPdfResponse} returns this
 */
proto.pdf_messages.GenerateNpaPdfResponse.prototype.clearAdditionalPdfsList = function() {
  return this.setAdditionalPdfsList([]);
};


/**
 * optional int32 total_pdf_count = 7;
 * @return {number}
 */
proto.pdf_messages.GenerateNpaPdfResponse.prototype.getTotalPdfCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.pdf_messages.GenerateNpaPdfResponse} returns this
 */
proto.pdf_messages.GenerateNpaPdfResponse.prototype.setTotalPdfCount = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


goog.object.extend(exports, proto.pdf_messages);
